import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, Play, Gift } from 'lucide-react';
export function IncludedSection() {
  const items = [{
    icon: BookOpen,
    title: 'Ebook completo',
    description: 'El sistema completo en formato digital. Lectura clara, directa, sin relleno.'
  }, {
    icon: Headphones,
    title: 'Audiobook',
    description: 'Escuchalo donde quieras. Ideal para integrar mientras hacés tu rutina.'
  }, {
    icon: Play,
    title: 'Videos explicativos',
    description: 'Videos cortos que profundizan cada fase con ejemplos reales.'
  }, {
    icon: Gift,
    title: 'Bonus exclusivo',
    description: 'Guía rápida de aplicación inmediata para tu próxima interacción.'
  }];
  return <section className="py-32 bg-secondary" data-id="element-114">
      <div className="max-w-5xl mx-auto px-6" data-id="element-115">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-white mb-16 text-center" data-id="element-116">
          ¿Qué incluye The F-Formula?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-117">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-6 bg-primary rounded-lg border border-white/5 hover:border-gold/20 transition-colors" data-id="element-118">
              <div className="bg-gold/10 p-3 rounded-lg mr-6" data-id="element-119">
                <item.icon className="text-gold" size={24} data-id="element-120" />
              </div>
              <div data-id="element-121">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-122">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-123">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}